import React, { Component, lazy, Suspense } from 'react';
import { createHashHistory } from 'history';
import { Switch, Redirect, Route } from "react-router-dom";
import Auth from "../../Layout/Auth";
import '../Assets/css/homedoc.scss';

const AccountPage = lazy(() => import('../Pages/AccountPage'))
import LoginSuccessRedirectPage from '../Pages/LoginSuccessRedirectPage';

class AccountRoute extends Component {
    render() {
        const history = createHashHistory();
        return (
            <Switch>
                <Route
                    exact
                    path="/"
                    render={() => (
                        <Auth history={history} allowedRoles={['app_admin', 'admin', 'user', 'staff']}>
                            <LoginSuccessRedirectPage history={history} location={location} />
                        </Auth>
                    )}
                />
                <Route
                    exact
                    path="/:lng"
                    render={() => (
                        <Auth history={history} allowedRoles={['app_admin', 'admin', 'user', 'staff']}>
                            <LoginSuccessRedirectPage history={history} location={location} />
                        </Auth>
                    )}
                />
                <Route
                    exact
                    path="/:lng/account"
                    render={() => (
                        <Auth history={history} allowedRoles={['app_admin', 'admin', 'user', 'staff']}>
                            <Suspense fallback={<Loading />}>
                                <AccountPage history={history} location={location} />
                            </Suspense>
                        </Auth>
                    )}
                />
            </Switch>
        );
    }
}
export default AccountRoute;

function Loading() {
    return (
        <>
            <div className="wrapper">
                <span>Loading...</span>
            </div>
        </>
    );
}
